import React from 'react'

export const ScrollDownIcon  = (props) =>  {
       return <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
       <circle cx="8.5" cy="8" r="7.5" fill="white" stroke="#D7D7DB"/>
       <path d="M6.5 6L8.5 8L10.5 6" stroke="#737373" stroke-linecap="round"/>
       <path d="M6.5 9.3335L8.5 11.3335L10.5 9.3335" stroke="#737373" stroke-linecap="round"/>
       </svg>       
}